// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapImage, BootstrapLink } from '../../../dsl/front';
import { ImageRatio } from '../../_contracts';
import { PublicationDate } from '../PublicationDate';
import { ReadingTime } from '../ReadingTime';
import { prepareImage } from '../../_filters';
/**
 * @author Sebastian Dziechciarz <sebastian.dziechciarz@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let ArticleAuthor = class ArticleAuthor extends Vue {
    get Component() {
        return this.link ? BootstrapLink : 'div';
    }
    get avatar() {
        var _a;
        if (!((_a = this.author) === null || _a === void 0 ? void 0 : _a.avatar)) {
            return;
        }
        return prepareImage(this.author.avatar, ImageRatio.Square, 64, this.isLazy);
    }
    get name() {
        if (!this.author) {
            return '';
        }
        return `${this.author.firstName} ${this.author.lastName}`;
    }
    get link() {
        var _a;
        if (!((_a = this.author) === null || _a === void 0 ? void 0 : _a.url)) {
            return '';
        }
        return this.author.url;
    }
    get hasExtraContent() {
        if (this.$slots.default) {
            return true;
        }
        if (this.hideDate) {
            return false;
        }
        return (this.showPublicationDate && !!this.publicationDate) || (this.showReadingTime && !!this.readingTime);
    }
};
__decorate([
    Prop({ type: Object, required: true })
], ArticleAuthor.prototype, "author", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "hideDate", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "isMobile", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "isLazy", void 0);
__decorate([
    Prop({ type: Number, required: false, default: null })
], ArticleAuthor.prototype, "readingTime", void 0);
__decorate([
    Prop({ type: String, required: false, default: null })
], ArticleAuthor.prototype, "publicationDate", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "shortenDate", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ArticleAuthor.prototype, "showAuthorAvatar", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ArticleAuthor.prototype, "showAuthorName", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "showInitialsWhenNoAvatar", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ArticleAuthor.prototype, "showPublicationDate", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "showReadingTime", void 0);
ArticleAuthor = __decorate([
    Component({
        name: 'ArticleAuthor',
        components: { BootstrapImage, BootstrapLink, PublicationDate, ReadingTime },
        template: `
    <div class="article-author">
      <component
        v-if="showAuthorAvatar || showInitialsWhenNoAvatar || showAuthorName"
        :is="Component"
        v-bind="link ? { link : { target: link } } : {}"
        class="article-author__wrap"
      >
        <BootstrapImage v-if="showAuthorAvatar && avatar && avatar.src && avatar.src.length"
                        v-bind="avatar" class="article-author__avatar img-avatar" />

        <div v-else-if="showInitialsWhenNoAvatar" class="article-author__initials">
          {{ name.split(' ')[0][0] }}{{ name.split(' ')[1][0] }}
        </div>

        <span v-if="showAuthorName && name && name.length" class="article-author__name">
          {{ name }}
        </span>
      </component>

      <div class="article-author__texts" v-if="hasExtraContent">
        <template v-if="!hideDate">
          <PublicationDate
            v-if="showPublicationDate"
            class="article-author__publication-time"
            :value="publicationDate"
            :shortenDate="shortenDate || isMobile"
          />

           <ReadingTime v-if="showReadingTime && readingTime" :time="readingTime" />
        </template>

        <slot />
      </div>
    </div>
  `
    })
], ArticleAuthor);
export { ArticleAuthor };
